export default __webpack_public_path__ + "static/media/Flag_of_Portugal.32d4a352.svg";